import React from 'react'
import { PushlyLoadingScreen } from './pushly-loading-screen'

export type BootBrandedLoadingProps = {
    /** The boot finished: the screen stays mounted as an overlay and fades out. */
    fadingOut?: boolean
}

/**
 * The Pushly loading screen, shown for every loading phase from the first moment of boot. Failure
 * screens stay on the dependency-free screens in boot-screens.
 */
export const BootBrandedLoading = ({ fadingOut = false }: BootBrandedLoadingProps) => (
    <div
        role={fadingOut ? undefined : 'status'}
        aria-live={fadingOut ? undefined : 'polite'}
        aria-hidden={fadingOut ? true : undefined}
        data-testid={fadingOut ? 'boot-fade' : 'boot-loading'}
    >
        <PushlyLoadingScreen active={!fadingOut} variant="app" fadingOut={fadingOut} />
    </div>
)
